module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-8ea1e8b2.png";